import React from 'react';

export const RightArrow = ({ height="25px", width="20px",style=''})=> (
    <svg role="presentation" aria-label=""  width={width} height={height} viewBox="0 0 26 33" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Symbols" stroke="none" strokeWidth="1" fill="rgb(13, 13, 15)" fillRule="evenodd">
           <polygon points="10.53 16.52 9.47 15.46 12.94 11.99 9.47 8.53 10.53 7.46 15.06 11.99 10.53 16.52"/>
        </g>
    </svg>
);
